import { Button, CircularProgress } from "@mui/material";
import { Stack } from "@mui/system";
import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import {
  Box,
  FormControl,
  Typography,
  useTheme,
  Modal,
  TextField
} from "@mui/material";
import { IDarkTheme } from "styles/darkTheme";
import { CustomButton } from "components/SharedComponents/CustomButton";
import { toast } from "react-toastify";
import { EmailRegex } from "utils/constants";
type ISignInFormModal = {
  open: boolean;
  handleClose: any;
};
const SignInFormModal = ({ open, handleClose }: ISignInFormModal) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme<IDarkTheme>();

  const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    role: "",
    hear: "",
    companySize: ""
  };
  const {
    control,
    formState: { errors, isValid },
    getValues,
    trigger
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues
  });

  const handleFormSubmit = async () => {
    const currentValues = getValues();
    trigger();
    if (isValid) {
      setIsLoading(true);

      try {
        //TODO : Implement submit
        handleClose();
        toast.success(
          "Your information is sent to us and we will contact you very soon!",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
          }
        );
      } catch (error) {}
      setIsLoading(false);
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4
        }}
        gap={2}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ alignSelf: "center" }}
        >
          Join us now!
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Fill this form with your information and we will contact you
          very soon.
        </Typography>
        <Stack gap={2}>
          <Controller
            control={control}
            name="first_name"
            rules={{
              required: "First name is required"
            }}
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="first name"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  error={error?.message ? true : false}
                  title="First Name"
                  variant="outlined"
                  label="First name"
                  sx={{
                    width: "100%"
                  }}
                />
                <ErrorMessage
                  style={{
                    color: "red", //TODO
                    fontSize: "0.85rem",
                    marginTop: "0.375rem"
                  }}
                  errors={errors}
                  name="first_name"
                  as="p"
                />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="last_name"
            rules={{
              required: "Last name is required"
            }}
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="last name"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  error={error?.message ? true : false}
                  title="Last Name"
                  variant="outlined"
                  label="Last name"
                  sx={{
                    width: "100%"
                  }}
                />
                <ErrorMessage
                  style={{
                    color: "red", //TODO
                    fontSize: "0.85rem",
                    marginTop: "0.375rem"
                  }}
                  errors={errors}
                  name="last_name"
                  as="p"
                />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="email"
            rules={{
              required: "Email name is required",
              pattern: {
                value: EmailRegex,
                message: "This Email is invalid"
              }
            }}
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="email"
                  type="email"
                  name="email"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  error={error?.message ? true : false}
                  title="E-mai"
                  variant="outlined"
                  label="E-mail"
                  sx={{
                    width: "100%"
                  }}
                />
                <ErrorMessage
                  style={{
                    color: "red", //TODO
                    fontSize: "0.85rem",
                    marginTop: "0.375rem"
                  }}
                  errors={errors}
                  name="email"
                  as="p"
                />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="companySize"
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="hear"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  title="Company size"
                  variant="outlined"
                  label="Company size"
                  sx={{
                    width: "100%"
                  }}
                />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="role"
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="role"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  title="Role"
                  variant="outlined"
                  label="Role"
                  sx={{
                    width: "100%"
                  }}
                />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="hear"
            render={({
              field: { onChange, value },
              fieldState: { error }
            }) => (
              <FormControl>
                <TextField
                  id="hear"
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  title="Where did you hear about us?"
                  variant="outlined"
                  label="Where did you hear about us?"
                  sx={{
                    width: "100%"
                  }}
                />
              </FormControl>
            )}
          />
        </Stack>
        <Stack
          direction="row"
          alignSelf={"center"}
          justifyContent="center"
          width="100%"
          gap={2}
        >
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              <CustomButton onClick={handleClose} layout="outline">
                Cancel
              </CustomButton>
              <CustomButton
                onClick={handleFormSubmit}
                layout="primary"
              >
                Submit
              </CustomButton>
            </>
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default SignInFormModal;
